import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
declare var $:any;

@Component({
  selector: 'app-superadmin-dashboard',
  templateUrl: './superadmin-dashboard.component.html',
  //styleUrls: ['./superadmin-dashboard.component.scss']
})
export class SuperadminDashboardComponent implements OnInit {

  constructor(private router:Router) { }

  ngOnInit(): void {
    //$.widget.bridge('uibutton', $.ui.button);  
  }

  toggle:any=false;
  menuitem:any=false;

  clickEvent(event:any){
    //if you just want to toggle the class; change toggle variable.
    this.toggle = !this.toggle;       
 }
//  async signout(){
// localStorage.removeItem('user_district');
// localStorage.removeItem('user_constituency');
// localStorage.removeItem('login_user_details');
// sessionStorage.removeItem('validUserToken');
// this.router.navigate(['']);
// await  window.location.reload();
//  }

async signout() {
  Swal.fire({
    title: 'Are you sure you want to sign out?',
    text: 'This will log you out of the system.',
    icon: 'warning',
    iconColor:'#015792',
    showCancelButton: true,
    confirmButtonColor: '#015792',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, sign out!',
    cancelButtonText: 'Cancel'
  }).then(async (result) => {
    if (result.isConfirmed) {
      // Remove items from local storage
      localStorage.removeItem('user_district');
      localStorage.removeItem('user_constituency');
      localStorage.removeItem('login_user_details');
      sessionStorage.removeItem('validUserToken');
     sessionStorage.clear();
      this.router.navigate(['login']).then(() => {
        window.location.reload();
      });
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      // Reload the page without removing local storage
      window.location.reload();
    }
  });
}
 footerdate=new Date().getFullYear();
}



